import React, { Component } from 'react';
import PropTypes from 'prop-types';
import validators from 'app/scripts/utils/validators';
import { navigateAction } from 'fluxible-router';
import Modal from 'utils/components/modal';
import LoginPageLogo from 'app/scripts/components/common/login/logo';
import LoginPageTitle from 'app/scripts/components/common/login/title';
import {
  getNetwork,
  isSocialLoginEnableForNetwork,
  setSpotId
} from 'app/scripts/services/app-state';
import logoutAccount from 'app/scripts/actions/account/logout';
import { ERROR, LOADING, SUCCESS } from '../../../../models/request-status';
import ExpiredModal from '../../../modals/expired';
import SocialConnect from '../../social-connect';
import TextField from '../../../common/inputs/text-field';
import DisclaimerAndRights from '../../../common/disclaimer-rights';
import { getAuthConfigs } from '../../api';

import LoginAccountAction from './actions/login';
import { connect } from 'react-redux';

const displayName = 'Login';

class Login extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: '',
      password: '',
      hasError: false,
      isLoaded: false,
      authConfigs: {
        email_connect_disabled: false,
        google_connect_disabled: false,
        twitter_connect_disabled: false
      }
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.expiredModal) {
      this.openExpiredModal();
    }
  }

  async componentDidMount() {
    const authConfigs = await getAuthConfigs();

    this.setState({ authConfigs, isLoaded: true });
  }

  navigate() {
    const { firstSpotId } = this.props;

    if (firstSpotId) {
      var url = `/spot/${firstSpotId}/moderation`;

      // TODO: move spotId to store
      setSpotId(firstSpotId);

      this.context.executeAction(navigateAction, { url });
    } else {
      this.context.executeAction(logoutAccount, {
        spotId: null,
        redirectUrl: 'https://www.spot.im/request-an-invite/'
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var { loginStatus } = this.props;
    if (loginStatus !== nextProps.loginStatus && nextProps.loginStatus === SUCCESS) {
      this.navigate();
    }
  }

  handleEmailChange(email) {
    this.setState({ email });
  }

  handlePasswordChange(password) {
    this.setState({ password });
  }

  login() {
    var { email, password, hasError } = this.state;
    var errorMessage =
      !email || !email.length || !password || !password.length || !validators.email(email);
    if (errorMessage) {
      hasError = true;
    }
    if (!errorMessage) {
      this.context.executeAction(LoginAccountAction, {
        email: email,
        password: password
      });
    }
    if (hasError !== this.state.hasError) {
      this.setState({ hasError });
    }
  }

  openExpiredModal() {
    this.refs.expiredModal.show();
  }

  closeExpiredModal() {
    this.refs.expiredModal.hide();
  }

  navigateToForgotPassword() {
    this.context.executeAction(navigateAction, {
      url: '/forgot-password'
    });
  }

  navigateToLogin = () => {
    context.executeAction(navigateAction, { url: `/network/${getNetwork().name}?userVersion=2` });
  };

  render() {
    var { loginStatus, disableSocialLogin } = this.props;
    var { hasError, isLoaded, authConfigs } = this.state;
    const {
      email_connect_disabled: isEmailConnectDisabled,
      google_connect_disabled: isGoogleConnectDisabled,
      twitter_connect_disabled: isTwitterConnectDisabled
    } = authConfigs ?? {};
    const isSocialConnectsDisabled = isGoogleConnectDisabled && isTwitterConnectDisabled;
    var message = null;
    const socialConnectTitleText = `You can ${!isEmailConnectDisabled ? 'also' : ''} log in with:`;

    if (hasError || loginStatus === ERROR) {
      message = (
        <div className={'error-message'}>
          <span>{'Something went wrong, please try again'}</span>
          <span>Please check your details and try again.</span>
        </div>
      );
    } else if (this.props.message) {
      message = <div className="success-message">{this.props.message}</div>;
    }

    var socialLogin = null;
    if (!disableSocialLogin && !isSocialConnectsDisabled) {
      socialLogin = socialLogin = (
        <SocialConnect
          isGoogleConnectDisabled={isGoogleConnectDisabled}
          isTwitterConnectDisabled={isTwitterConnectDisabled}
          titleText={socialConnectTitleText}
        />
      );
    }

    if (isSocialLoginEnableForNetwork() === true && !isSocialConnectsDisabled) {
      socialLogin = socialLogin = (
        <SocialConnect
          isGoogleConnectDisabled={isGoogleConnectDisabled}
          isTwitterConnectDisabled={isTwitterConnectDisabled}
          titleText={socialConnectTitleText}
        />
      );
    }

    var network = getNetwork();
    var buttonStyle = {
      backgroundColor: network.color
    };

    var className = 'form-wrapper';
    if (message) {
      className += ' has-message';
    }

    return (
      isLoaded && (
        <div className="form">
          <div className={className}>
            {message}
            <div className="main-content">
              <LoginPageLogo />
              <LoginPageTitle />
              {!isEmailConnectDisabled && (
                <>
                  <div className="fields">
                    <div>
                      <div className="input-title">Email</div>
                      <TextField
                        onChange={this.handleEmailChange.bind(this)}
                        value={this.state.email}
                      />
                    </div>
                    <div>
                      <div className="link-container">
                        <span className="input-title">Password</span>
                        <span
                          className="forgot-link"
                          onClick={this.navigateToForgotPassword.bind(this)}
                        >
                          Forgot?
                        </span>
                      </div>
                      <TextField
                        type="password"
                        onEnterPress={this.login.bind(this)}
                        onChange={this.handlePasswordChange.bind(this)}
                        value={this.state.password}
                      />
                    </div>
                  </div>
                  <button
                    className="continue-button"
                    style={buttonStyle}
                    onClick={this.login.bind(this)}
                  >
                    {loginStatus === LOADING ? <span className="spinner" /> : 'Log In'}
                  </button>
                </>
              )}
              {socialLogin}
            </div>
            <DisclaimerAndRights />
            <Modal ref="expiredModal" className="confirm-modal">
              <ExpiredModal onClose={this.closeExpiredModal.bind(this)} />
            </Modal>
          </div>
        </div>
      )
    );
  }
}

Login.displayName = displayName;

Login.propTypes = {
  message: PropTypes.string,
  expiredModal: PropTypes.bool,
  loginStatus: PropTypes.string,
  disableSocialLogin: PropTypes.bool,
  isEmailConnectDisabled: PropTypes.bool
};

Login.contextTypes = {
  getStore: PropTypes.func.isRequired,
  executeAction: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    firstSpotId: state.spotSelector?.spots?.[0]?.id,
    loginStatus: state.auth.loginStatus
  };
}

export default connect(mapStateToProps)(Login);
